// test1671
(1671 && 0);
